__turbopack_context__.v({
  "box_desc_container": "WhyChooseMbaCard-module-scss-module__Wta8vq__box_desc_container",
  "container": "WhyChooseMbaCard-module-scss-module__Wta8vq__container",
  "content_wrapper": "WhyChooseMbaCard-module-scss-module__Wta8vq__content_wrapper",
  "current_text": "WhyChooseMbaCard-module-scss-module__Wta8vq__current_text",
  "desc_text": "WhyChooseMbaCard-module-scss-module__Wta8vq__desc_text",
  "hidden_text": "WhyChooseMbaCard-module-scss-module__Wta8vq__hidden_text",
  "img_container": "WhyChooseMbaCard-module-scss-module__Wta8vq__img_container",
  "img_wrapper": "WhyChooseMbaCard-module-scss-module__Wta8vq__img_wrapper",
});
